import React, { Component, Fragment } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { Helmet } from "react-helmet";
// Styling
import "./App.css";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
{/*
import SignUpForm from './components/SignUpForm';
import SignUpDRPForm from './components/SignUpDRPForm';
import RequestARepForm from './components/RequestARepForm';
import UnsubscribeForm from './components/UnsubscribeForm';
*/}



class App extends Component {
  render() {
    const pathName = window.pathName;
    return (
      <Fragment>
        <Helmet>
          <title>Acadia LTC</title>
        </Helmet>
          <BrowserRouter>
            <Switch>
              {/*
              <Route location={ pathName } exact path="/" component={ SignUpForm } />
              <Route location={ pathName } exact path="/sign-up" component={ SignUpForm } />
              <Route location={ pathName } exact path="/sign-up-drp" component={ SignUpDRPForm } />
              <Route location={ pathName } exact path="/request-a-rep" component={ RequestARepForm } />
              <Route location={ pathName } exact path="/unsubscribe" component={ UnsubscribeForm } />
              */}
            </Switch>
          </BrowserRouter>
      </Fragment>
    );
  }
}

export default App;